<template>
  <div>
    <div class="row">
      <div class="flex md6">
        <va-tabs grow v-model="tabsState">
          <va-tab>Mes tâches</va-tab>
          <va-tab>Toutes les tâches</va-tab>
        </va-tabs>
        <va-separator />
      </div>

      <div class="flex md4 offset--md2">
        <div class="row row-inside">
          <h5 class="custom-label-task" :style="{ color: this.$themes.primary  }">Tâches:</h5>
          <va-button-toggle
            outline
            class="toggle-activite"
            v-model="showClosed"
            :options="options"
          />
        </div>
      </div>
    </div>
    <va-data-table
      class="va-table--hoverable va-table--stripped"
      :fields="fields"
      :data="filteredData"
      no-data-label="Aucune tâche correspondant à ces critéres"
      @row-clicked="showEntreprise"
      :per-page="10"
      clickable
    >
      <template slot="statuts" slot-scope="props">
        <va-badge
          class="fullwidth task-badge"
          :color="props.rowData.statut.color"
        >{{props.rowData.statut.msg}}</va-badge>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex } from "lodash";
export default {
  name: "taskComponent",

  data() {
    return {
      relanceList: [],
      tabsState: 0,
      showClosed: "open",
      options: [
        { label: "En cours", value: "open" },
        { label: "Toutes", value: "all" },
        { label: "Terminées", value: "closed" }
      ]
    };
  },
  mounted() {
    this.loadRelances();
  },
  methods: {
    async loadRelances() {
      try {
        let rlist = await axios.get("/api/relance-list", {
          params: {
            idutilisateur: this.$store.getters.user.idutilisateurs
          }
        });
        for (let value of rlist.data) {
          value.affectation_username = value.affectation_username
            ? value.affectation_username
            : "";
          value.dayfilter = value.days_count.toString();
          value.statut = this.getStatus(value);
        }

        this.relanceList = rlist.data;
      } catch (error) {
        console.log(error);
      }
    },
    getStatus(value) {
      let res = {
        color: "warning",
        msg: "Aujourd'hui"
      };
      if (value.date_cloture) {
        res.color = "success";
        res.msg = "Terminé le " + value.date_cloture;
        return res;
      }
      let txtJours = " jour";
      if (Math.abs(value.days_count) > 1) {
        txtJours = " jours";
      }

      if (value.days_count > 0) {
        res.color = "danger";
        res.msg = "Passée de " + value.days_count + txtJours;
      }

      if (value.days_count < 0) {
        res.color = "info";
        res.msg = "Dans " + Math.abs(value.days_count) + txtJours;
      }

      return res;
    },
    showEntreprise(value) {
      this.$store.commit("setLoadEntreprise", value.identreprise);
    }
  },
  computed: {
    fields() {
      return [
        {
          name: "nom",
          title: "Entreprise",
          sortField: "nom",
          width: "15%"
        },

        {
          name: "text",
          title: "Tâches",
          sortField: "text",
          width: "20%"
        },
        {
          name: "date",
          title: "Date d'échéance",
          sortField: "date",
          width: "5%"
        },
        {
          name: "affectation_username",
          title: "Affecté à",
          sortField: "affectation_username",
          width: "15%"
        },
        {
          name: "__slot:statuts",
          title: "Dans",
          sortField: "dayfilter",
          width: "10%"
        }
      ];
    },
    filteredData() {
      let filteredData = this.relanceList;

      return filteredData.filter(item => {
        let boolcond = true;

        if (this.tabsState === 0 && item.is_mine === 0) {
          boolcond = false;
        }

        if (this.showClosed === "open" && item.date_cloture) {
          boolcond = false;
        }

        if (this.showClosed === "closed" && !item.date_cloture) {
          boolcond = false;
        }

        return boolcond;
      });
    }
  }
};
</script>

<style lang="scss">
.padded-input > * > .flex {
  padding-left: 0.25rem;
}

.task-table-scrollable {
  height: 300px;
  overflow-y: auto;
}

.task-badge > * {
  font-size: 1.2em;
}
.custom-label-task {
  position: relative;
  top: 0.5rem;
  margin-right: 0.5rem;
}
</style>
